export const numToFixed = (num: string | number, range: number = 2): string => {
  if (Number.isNaN(Number(num))) {
    return '--';
  }
  return Number(num).toFixed(range);
};
